// Copyright (c) 2024 Quantum Xchange
'use strict'

import { Alert, Col, Container, Row } from 'react-bootstrap'

const ErrorBoundaryFallback = () => {
    return (
        <Container>
            <Row className="justify-content-md-center mt-5">
                <Col sm={12} md={8} lg={6} xl={5} className="text-center">
                    <Alert variant="danger">
                        <h1 className="mt-3 mb-4">An unexpected error occurred</h1>
                        <h3 className="mb-2">
                            <a href="#" onClick={() => window.location.reload()}>
                                Click here
                            </a>
                            <span className="ms-1">to reset the application</span>
                        </h3>
                    </Alert>
                </Col>
            </Row>
        </Container>
    )
}

export default ErrorBoundaryFallback
